import { LOCAL_SESSION_KEY, LOCAL_UID_KEY } from './sessionKeys';

// Extracts a downloadable file from a live agent attachment, either an `agentattachment` event
// (value: { fileName, fileUrl, mimeType, fileSize, label }) or an AgentAttachmentCard in attachments.
// Only http(s) URLs are accepted.
export const getAgentAttachment = (activity) => {
  const card = Array.isArray(activity?.attachments)
    ? activity.attachments.find(item => item?.contentType === 'AgentAttachmentCard')
    : null;
  const isAttachmentEvent = activity?.type === 'event' && activity.name === 'agentattachment';
  const content = isAttachmentEvent ? activity.value : card?.content;
  if (typeof content?.fileUrl !== 'string' || !/^https?:\/\//i.test(content.fileUrl.trim())) return null;
  return {
    fileUrl: content.fileUrl.trim(),
    fileName: typeof content.fileName === 'string' && content.fileName.trim() ? content.fileName.trim() : 'attachment',
    mimeType: typeof content.mimeType === 'string' ? content.mimeType : '',
    fileSize: content.fileSize !== undefined && Number.isFinite(Number(content.fileSize)) ? Number(content.fileSize) : null,
    agentName: typeof content.label === 'string' && content.label.trim() ? content.label.trim() : null,
  };
};

export const logAgentAvailability = (activity) => {
  const activityName = String(activity?.name || '').toLowerCase();
  const value = activity?.value;
  const isAvailabilityActivity = activityName.includes('availability')
    || activityName === 'liveagentstatus';

  if (!isAvailabilityActivity) return;

  const countKey = [
    'availableAgents',
    'agentsAvailable',
    'availableAgentCount',
    'agentCount',
  ].find((key) => Number.isFinite(Number(value?.[key])));

  if (countKey) {
    console.log('[DirectLine] agents available:', Number(value[countKey]));
  } else {
    console.log('[DirectLine] agent availability update received, but no count field was provided:', value);
  }
};

export const getDirectLineChannelData = (userEmail) => {
  const queryParams = new URLSearchParams(window.location.search);
  return {
    sessionId: queryParams.get('session') || sessionStorage.getItem(LOCAL_SESSION_KEY) || '',
    uuid: queryParams.get('uid') || sessionStorage.getItem(LOCAL_UID_KEY) || '',
    userEmail: userEmail || '',
  };
};

// Appends an AI reply, dropping text that duplicates the current turn's replies.
export const appendAiReply = (messages, reply) => {
  const textKey = text => typeof text === 'string' ? text.replace(/\s+/g, ' ').trim() : '';
  const lastUserIndex = messages.map(message => message.role).lastIndexOf('user');
  const turnReplies = messages.slice(lastUserIndex + 1).filter(message => message.agentType === 'ai');
  const contentKey = textKey(reply.content);
  const proactiveKey = textKey(reply.proactiveMessage);
  const content = contentKey && turnReplies.some(message => textKey(message.proactiveMessage) === contentKey)
    ? '' : reply.content;
  const proactiveMessage = proactiveKey && (proactiveKey === contentKey || turnReplies.some(message =>
    textKey(message.content) === proactiveKey || textKey(message.proactiveMessage) === proactiveKey))
    ? '' : reply.proactiveMessage;
  return content || proactiveMessage || reply.orderCard
    ? [...messages, { ...reply, content, proactiveMessage }] : messages;
};
